import { get } from 'lodash';

const apiConfig = window.apiConfig;
export const getLogin = (request) => {

    const userReq = {
        email: get(request, 'email'),
        password: get(request, 'password')
    }

    return fetch(`https://secretsantabe.reinhardtvanwyk.com/user/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify(userReq),
    }).then(res => {
        if (res.status !== 200) {
            console.log("error")
        } else {
            return res.json().then(data => {
                if (data.message) {
                    window.sessionStorage.jwt = data.message
                    return true;
                } else {
                    return false;
                }
            })
        }
    })

}

export const getPartyDetailsForUser = (partyId, email) => {
    console.log(partyId);
    return fetch(`https://secretsantabe.reinhardtvanwyk.com/party/getUser`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body:  JSON.stringify({
            PartyId: partyId,
            Email: email
        })
    }).then(res => {
        if (res.status !== 200) {
            console.log("error")
        } else {
            return res.json().then(data => data)
        }
    })

}